export let sortOptions = [
    {
        disabled: true,
        value: '',
        label: 'Order By Vote'
    },
    {
        disabled: false,
        value: 'asc',
        label: 'Most voted'
    },
    {
        disabled: false,
        value: 'desc',
        label: 'Less voted'
    }
]

export const LOCAL_STORAGE_KEY = 'LINK_LIST'